import { createAction } from 'redux-actions'

import { GET_BLOGS, GET_ARTICLE_BY_ID } from './constants'
import { getBlogsApi, getArticleApi } from './api'

export const getBlogsAction = createAction(GET_BLOGS, async (page) => await getBlogsApi(page))
export const getArticleByIdAction = createAction(GET_ARTICLE_BY_ID, async (id) => await getArticleApi(id))
